
import { mapGetters } from "vuex";

export default {
  props: {
    treeId: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: false,
      default: () => [],
    },

    initialPagination: {
      type: Object,
      required: false,
      default: () => ({
        perPage: 24,
        totalPages: 0,
        totalProducts: 0,
        currentPage: 1,
      }),
    },
  },

  data() {
    return {
      products: this.items,
      pagination: { ...this.initialPagination },
      isEmpty: !this.items.length,
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      isBackActive: "CONFIG/IS_BACK_ACTIVE",
    }),
  },

  methods: {
    async getProducts() {
      this.isLoading = true;

      this.products = [];

      try {
        const result = await this.$axios.$get("products", {
          params: {
            treeId: this.treeId,
            items: this.pagination.perPage,
            page: this.pagination.currentPage,
            order: this.sortBy,
          },
        });

        this.products = result.products;
        this.pagination.totalProducts = result.total;
        this.pagination.totalPages = Math.ceil(
          result.total / this.pagination.perPage
        );
      } catch (err) {
        this.__logError(err);
      }

      this.isEmpty = !this.products.length;
      this.isLoading = false;
    },

    updateProducts(page = 1) {
      this.pagination.currentPage = page;

      this.__toTop();
      this.updateURL();
      this.getProducts();
    },

    updateURL() {
      const newQuery = {};

      if (this.pagination.currentPage !== 1) {
        newQuery.page = this.pagination.currentPage;
      }

      this.$router.push({
        query: newQuery,
      });
    },

    initPagination() {
      const page = this.$route.query.page;

      if (page) {
        if (!isNaN(parseInt(page))) {
          this.pagination.currentPage = parseInt(page);
        } else {
          this.__logError("Invalid URL page value");
        }
      }
    },
  },

  created() {
    this.initPagination();
  },
};
